import React from 'react';
import Card from './Cards';

export default function Display() {
    return (
        <div>
            <h1>Portfolio</h1>
            <Card />
        </div>
    );
}
